module.exports = __webpack_public_path__ + "72900de1fd94401daabba831bf1b902d.jpg";